// extracted by mini-css-extract-plugin
export default {"control":"RemarkPopup_control__FAkpP"};